package br.com.vvrefeicoes.portal.core.util

/**
 * Disponibiliza um PDF (em base64) para o usuário. Retorna `true` quando a
 * plataforma conseguiu iniciar o download/compartilhamento.
 */
expect fun savePdf(
    fileName: String,
    base64: String,
): Boolean

/** `true` quando a plataforma implementa export/compartilhamento de PDF. */
expect fun isPdfExportSupported(): Boolean

private const val BASE64_ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"

fun decodeBase64(value: String): ByteArray {
    val clean = value.replace(Regex("\\s"), "").trimEnd('=')
    val output = ArrayList<Byte>(clean.length * 3 / 4)
    var buffer = 0
    var bits = 0
    clean.forEach { character ->
        val digit = BASE64_ALPHABET.indexOf(character)
        if (digit < 0) return@forEach
        buffer = (buffer shl 6) or digit
        bits += 6
        if (bits >= 8) {
            bits -= 8
            output.add(((buffer shr bits) and 0xff).toByte())
        }
    }
    return output.toByteArray()
}

fun encodeBase64(bytes: ByteArray): String {
    val output = StringBuilder()
    var index = 0
    while (index < bytes.size) {
        val first = bytes[index].toInt() and 0xFF
        val second = if (index + 1 < bytes.size) bytes[index + 1].toInt() and 0xFF else -1
        val third = if (index + 2 < bytes.size) bytes[index + 2].toInt() and 0xFF else -1
        output.append(BASE64_ALPHABET[first shr 2])
        output.append(BASE64_ALPHABET[((first and 0x03) shl 4) or (if (second >= 0) second shr 4 else 0)])
        if (second >= 0) {
            output.append(BASE64_ALPHABET[((second and 0x0F) shl 2) or (if (third >= 0) third shr 6 else 0)])
        } else {
            output.append('=')
        }
        if (third >= 0) {
            output.append(BASE64_ALPHABET[third and 0x3F])
        } else {
            output.append('=')
        }
        index += 3
    }
    return output.toString()
}
